import { observer } from 'mobx-react-lite';
import type { ApplicationSdk } from './core/sdk';
import { OrderDialog, OrderEditDialog } from './features/orders/manager';
import { TrainingDialog, EditFolderDialog } from './features/training/manager';
import { ProductDialog, CategoryDialog } from './features/products';
import { EmployeeDialog } from './features/employees';
import { ManagerDialog } from './features/managers';
import { ObjectDialog } from './features/objects';
import { KnowledgeDialog } from './features/kihub';
import RequestDialog from './features/requests/manager/components/RequestDialog';

const DialogView = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    return (
        <>
            {sdk.currentDialog.id === 'order' && <OrderDialog sdk={sdk} />}
            {sdk.currentDialog.id === 'editorder' && <OrderEditDialog sdk={sdk} />}
            {sdk.currentDialog.id === 'editfolder' && <EditFolderDialog sdk={sdk} />}
            {sdk.currentDialog.id === 'edittraining' && <TrainingDialog sdk={sdk} />}
            {sdk.currentDialog.id === 'category' && <CategoryDialog sdk={sdk} />}
            {sdk.currentDialog.id === 'product' && <ProductDialog sdk={sdk} />}
            {sdk.currentDialog.id === 'employee' && <EmployeeDialog sdk={sdk} />}
            {sdk.currentDialog.id === 'manager' && <ManagerDialog sdk={sdk} />}
            {sdk.currentDialog.id === 'object' && <ObjectDialog sdk={sdk} />}
            {sdk.currentDialog.id === 'knowledge' && <KnowledgeDialog sdk={sdk} />}
            {sdk.currentDialog.id === 'request' && <RequestDialog sdk={sdk} />}
        </>
    );
});

export default DialogView;
